<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input (click)="date.open()" [formControl]="element" [matDatepicker]="date" matInput placeholder="Datum"
           readonly type="text">
    <mat-datepicker #date></mat-datepicker>
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
